import { createSlice } from '@reduxjs/toolkit';
import type { ModelosDecursoState } from '../../types/modelosDecurso';
import { listarModelosDecurso } from './actions';
const initialState: ModelosDecursoState = {
  items: [],
  total: 0,
  page: 1,
  loading: false,
  error: null,
  requestId: null,
};
const slice = createSlice({
  name: 'modelosDecurso',
  initialState,
  reducers: { limparModelosDecurso: () => initialState },
  extraReducers: (builder) => {
    builder
      .addCase(listarModelosDecurso.pending, (state, action) => {
        state.requestId = action.meta.requestId;
        state.page = action.meta.arg.page;
        state.loading = true;
        state.error = null;
        state.items = [];
      })
      .addCase(listarModelosDecurso.fulfilled, (state, action) => {
        if (state.requestId !== action.meta.requestId) return;
        state.items = action.payload.items;
        state.total = action.payload.total;
        state.page = action.meta.arg.page;
        state.loading = false;
      })
      .addCase(listarModelosDecurso.rejected, (state, action) => {
        if (state.requestId !== action.meta.requestId) return;
        state.loading = false;
        state.error =
          action.payload ?? action.error.message ?? 'Não foi possível carregar os modelos.';
      });
  },
});
export const { limparModelosDecurso } = slice.actions;
export const modelosDecursoReducer = slice.reducer;
